import { getArtworkFile, getEditorUrl, loadArtwork } from '../thunks/artwork';

export const artworksReducer = (builder) => {
  builder
    .addCase(getEditorUrl.fulfilled, (state, action) => {
      const editorUrl = action.payload || '';
      state.editorUrl.value = editorUrl;
      state.editorUrl.loading = false;
    })
    .addCase(getEditorUrl.pending, (state) => {
      state.editorUrl.loading = true;
    })
    .addCase(getEditorUrl.rejected, (state) => {
      state.editorUrl.loading = false;
    });
  builder
    .addCase(getArtworkFile.fulfilled, (state, action) => {
      const document = action.payload || {};
      state.artworkFile.value = document;
      state.artworkFile.loading = false;
    })
    .addCase(getArtworkFile.pending, (state) => {
      state.artworkFile.loading = true;
    })
    .addCase(getArtworkFile.rejected, (state) => {
      state.artworkFile.loading = false;
    });
  builder
    .addCase(loadArtwork.fulfilled, (state) => {
      state.loadingDocument = false;
    })
    .addCase(loadArtwork.pending, (state) => {
      state.loadingDocument = true;
    })
    .addCase(loadArtwork.rejected, (state) => {
      state.loadingDocument = false;
    });
};
